import '../../app.scss';
import React, { useEffect } from "react";
import Banner from './main-banner/Banner.js';
import Footer from './footer/Footer.js';





function Landing() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])


  return (
    <>
      <Banner />
      <Footer/>
    </>
  );
}

export default Landing;
